import { gql } from '@apollo/client'

export const GET_CAPTAIN_ROUTE_BOAT_HISTORY_LIST = gql`
    query GetCaptainRouteBoatHistory(
        $historyId: String
        $captainId: String
        $routeId: String
        $boatId: String
        $activityDate: LocalDate!
    ) {
        getCaptainRouteBoatHistory(
            history_id: $historyId
            captain_id: $captainId
            route_id: $routeId
            boat_id: $boatId
            activity_date: $activityDate
        ) {
            code
            success
            message
            history {
                is_trip_private
                history_id
                captain_id
                captain {
                    id

                    user_info {
                        given_name
                        family_name
                    }
                    is_active
                }
                route_id
                route {
                    route_id
                    master_route {
                        route_type {
                            code
                            description {
                                en
                                ar
                            }
                        }
                    }
                    route_name {
                        en
                        ar
                    }
                    status_code
                    route_trip {
                        trip_id
                        trip_name {
                            en
                            ar
                        }
                        start_time
                        end_time
                    }
                }
                trip {
                    trip_id
                    trip_name {
                        en
                        ar
                    }
                    route_id
                    start_time
                    end_time
                    status {
                        code
                        description {
                            en
                            ar
                        }
                    }
                }
                boat_id
                boat {
                    id
                    name {
                        en
                        ar
                    }
                }
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
                activity_date
                start_time
                end_time
                captain_activity
            }
        }
    }
`

export const GET_CAPTAIN_ROUTE_BOAT_HISTORY_WAYPOINTS_LIST = gql`
    query GetCaptainRouteBoatHistory(
        $historyId: String
        $captainId: String
        $routeId: String
        $boatId: String
        $activityDate: LocalDate!
    ) {
        getCaptainRouteBoatHistory(
            history_id: $historyId
            captain_id: $captainId
            route_id: $routeId
            boat_id: $boatId
            activity_date: $activityDate
        ) {
            code
            success
            message
            history {
                is_trip_private
                history_id
                captain_id
                waypoints {
                    history_id
                    location_id
                    location {
                        id
                        name {
                            en
                            ar
                        }
                        address {
                            unit_no
                            road_no
                            block_no
                            contact
                            area
                            landmark
                        }
                        geo {
                            lat
                            lng
                        }
                        contact {
                            email
                            phone_number
                        }
                        user_audit {
                            created_by
                            created_date
                            modified_by
                            modified_date
                        }
                    }
                    stop_number
                    arrival_time
                    departure_time
                    metric {
                        expected_checkin_passengers
                        expected_checkout_passengers
                        expected_stay_passengers
                    }
                    trip_date
                    status {
                        code
                        description {
                            en
                            ar
                        }
                    }
                }
                captain {
                    id
                    user_info {
                        given_name
                        family_name
                    }
                    is_active
                }
                captain_id2
                captain2 {
                    id
                    user_info {
                        given_name
                        family_name
                    }
                    email
                    user_roles
                    cognito_status
                    is_active
                }
                seaman_id1
                seaman1 {
                    id
                    user_info {
                        given_name
                        family_name
                    }
                    email
                    user_roles
                    cognito_status
                    is_active
                }
                seaman_id2
                seaman2 {
                    id
                    user_info {
                        given_name
                        family_name
                    }
                    email
                    user_roles
                    cognito_status
                    is_active
                }
                route_id
                route {
                    route_id
                    route_name {
                        en
                        ar
                    }
                    status_code
                    route_trip {
                        trip_id
                        trip_name {
                            en
                            ar
                        }
                        start_time
                        end_time
                    }
                }
                trip {
                    trip_id
                    trip_name {
                        en
                        ar
                    }
                    route_id
                    start_time
                    end_time
                    status {
                        code
                        description {
                            en
                            ar
                        }
                    }
                }
                boat_id
                boat {
                    id
                    name {
                        en
                        ar
                    }
                }
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
                activity_date
                start_time
                end_time
                captain_activity
                luggage_boats {
                    id
                    name {
                        en
                        ar
                    }
                }
            }
        }
    }
`

export const GET_VESSEL_CHECKLIST_SUBMISSION_LIST = gql`
    query GetVesselChecklistSubmission(
        $fromDate: LocalDate!
        $toDate: LocalDate!
        $page: PageInput!
        $boatId: String
        $captainId: String
    ) {
        getVesselChecklistSubmission(
            from_date: $fromDate
            to_date: $toDate
            page: $page
            boat_id: $boatId
            captain_id: $captainId
        ) {
            code
            success
            message
            total_count
            submissions {
                submission_id
                vessel {
                    boat_id
                    boat {
                        id
                        name {
                            en
                            ar
                        }
                        details {
                            reg_number
                        }
                        status {
                            code
                        }
                    }
                }
                captain_id
                captain {
                    id
                    user_info {
                        given_name
                        family_name
                    }
                    user_roles
                    is_active
                }
                submission_date
                status {
                    code
                }
                audit_info {
                    created_by
                    created_date
                    modified_by
                    modified_date
                }
            }
        }
    }
`
export const GET_VESSEL_CHECKLIST_SUBMISSION_DETAILS = gql`
    query GetVesselChecklistSubmission(
        $fromDate: LocalDate!
        $toDate: LocalDate!
        $page: PageInput!
        $boatId: String
        $captainId: String
        $submissionId: String
    ) {
        getVesselChecklistSubmission(
            from_date: $fromDate
            to_date: $toDate
            page: $page
            boat_id: $boatId
            captain_id: $captainId
            submission_id: $submissionId
        ) {
            code
            success
            message
            total_count
            submissions {
                submission_id
                vessel {
                    boat_id
                    boat {
                        id
                        name {
                            en
                            ar
                        }
                        details {
                            boat_type {
                                code
                            }
                            reg_number
                        }
                        status {
                            code
                        }
                        user_audit {
                            created_by
                            created_date
                            modified_by
                            modified_date
                        }
                    }
                }
                captain_id
                captain {
                    id
                    email
                    user_info {
                        phone_number
                        given_name
                        family_name
                    }
                    user_roles
                    is_active
                }
                checklist_category {
                    category_id
                    description {
                        en
                        ar
                    }
                    checklist_entries {
                        entry_id
                        checklist_id
                        checklist {
                            checklist_id
                            category_id
                            item_name {
                                en
                                ar
                            }
                        }
                        item_status {
                            is_checked
                            remarks
                        }
                    }
                }
                submission_date
                status {
                    code
                }
                audit_info {
                    created_by
                    created_date
                    modified_by
                    modified_date
                }
                additional_info {
                    remarks
                    attachments {
                        file_name
                        size
                        mime_type
                        s3_key
                    }
                }
                boat_engine_log {
                    port_engine_hours
                    port_center_engine_hours
                    starboard_center_engine_hours
                    starboard_engine_hours
                    generator_hours
                    fuel_level_percent
                    diesel_level_percent
                    remarks
                    last_updated_on
                }
            }
        }
    }
`

// export const GET_VESSEL_DEFECT_SUBMISSION_LIST = gql`
//     query GetVesselDefectSubmission(
//         $fromDate: LocalDate!
//         $toDate: LocalDate!
//         $searchString: String
//         $page: PageInput!
//     ) {
//         getVesselDefectSubmission(from_date: $fromDate, to_date: $toDate, search_string: $searchString, page: $page) {
//             code
//             success
//             message
//             total_count
//             defects {
//                 defect_submission_id
//                 vessel {
//                     boat_id
//                     boat {
//                         id
//                         name {
//                             en
//                             ar
//                         }
//                         details {
//                             reg_number
//                         }
//                     }
//                 }
//                 captain_id
//                 captain {
//                     id
//                     user_info {
//                         given_name
//                         family_name
//                     }
//                 }
//                 defect_date
//                 audit_info {
//                     created_by
//                     created_date
//                     modified_by
//                     modified_date
//                 }
//                 defect_status {
//                     code
//                     description {
//                         en
//                         ar
//                     }
//                 }
//             }
//         }
//     }
// `

export const GET_VESSEL_DEFECT_SUBMISSION_LIST = gql`
    query GetVesselDefectSubmission(
        $defectSubmissionId: String
        $boatId: String
        $fromDate: LocalDate!
        $toDate: LocalDate!
        $defectStatus: String
        $page: PageInput!
    ) {
        getVesselDefectSubmission(
            defect_submission_id: $defectSubmissionId
            boat_id: $boatId
            from_date: $fromDate
            to_date: $toDate
            defect_status: $defectStatus
            page: $page
        ) {
            code
            success
            message
            total_count
            defects {
                defect_submission_id
                vessel {
                    boat_id
                    boat {
                        id
                        name {
                            en
                            ar
                        }
                        details {
                            boat_type {
                                code
                            }
                            reg_number
                            capacity
                            features_amenities {
                                code
                            }
                            safety_equipment {
                                code
                            }
                            images {
                                file_name
                                size
                                mime_type
                                s3_key
                            }
                        }
                        status {
                            code
                        }
                        seat_layout {
                            layout_id
                            layout_key
                            num_rows
                            num_columns
                            seats_config {
                                seats {
                                    row
                                    column
                                    seat_number
                                }
                            }
                        }
                        user_audit {
                            created_by
                            created_date
                            modified_by
                            modified_date
                        }
                    }
                }
                captain_id
                captain {
                    id
                    email
                    user_info {
                        phone_number
                        phone_number_verified
                        given_name
                        family_name
                        nationality_code
                        date_of_birth
                        locale
                        photo {
                            file_name
                            size
                            mime_type
                            s3_key
                        }
                    }
                    user_roles
                    cognito_status
                    additional_info {
                        job_title
                        document_number
                        document_type {
                            code
                        }
                        document {
                            file_name
                            size
                            mime_type
                            s3_key
                        }
                        profile_photo {
                            file_name
                            size
                            mime_type
                            s3_key
                        }
                    }
                    is_active
                }
                inspection {
                    inspector_id
                    inspected_date
                    inspector {
                        id
                        email
                        user_roles
                        cognito_status
                        is_active
                    }
                    remarks
                    attachments {
                        file_name
                        size
                        mime_type
                        s3_key
                    }
                }
                defect_date
                defects {
                    defect_checklist_code
                    defect_checklist {
                        code
                        description {
                            en
                        }
                    }
                    remarks
                    is_defect
                    attachments {
                        file_name
                        size
                        mime_type
                        s3_key
                    }
                }
                audit_info {
                    created_by
                    created_date
                    modified_by
                    modified_date
                }
                defect_status {
                    code
                    description {
                        en
                        ar
                    }
                }
            }
        }
    }
`

// export const GET_VESSEL_CHECK_SUBMISSION_DETAILS = gql`
//     query GetVesselDefectSubmission(
//         $fromDate: LocalDate!
//         $toDate: LocalDate!
//         $searchString: String
//         $page: PageInput!
//     ) {
//         getVesselDefectSubmission(from_date: $fromDate, to_date: $toDate, search_string: $searchString, page: $page) {
//             code
//             success
//             message
//             total_count
//             defects {
//                 defect_submission_id
//                 vessel {
//                     boat_id
//                     boat {
//                         id
//                         name {
//                             en
//                             ar
//                         }
//                         details {
//                             boat_type {
//                                 code
//                             }
//                             reg_number
//                             capacity
//                             features_amenities {
//                                 code
//                             }
//                             safety_equipment {
//                                 code
//                             }
//                             images {
//                                 file_name
//                                 size
//                                 mime_type
//                                 s3_key
//                             }
//                         }
//                         status {
//                             code
//                         }
//                         seat_layout {
//                             layout_id
//                             layout_key
//                             num_rows
//                             num_columns
//                             seats_config {
//                                 seats {
//                                     row
//                                     column
//                                     seat_number
//                                 }
//                             }
//                         }
//                         user_audit {
//                             created_by
//                             created_date
//                             modified_by
//                             modified_date
//                         }
//                     }
//                 }
//                 captain_id
//                 captain {
//                     id
//                     email
//                     user_info {
//                         phone_number
//                         phone_number_verified
//                         given_name
//                         family_name
//                         locale
//                         photo {
//                             file_name
//                             size
//                             mime_type
//                             s3_key
//                         }
//                     }
//                     user_roles
//                     cognito_status
//                     additional_info {
//                         job_title
//                         document_number
//                         document_type {
//                             code
//                         }
//                         document {
//                             file_name
//                             size
//                             mime_type
//                             s3_key
//                         }
//                         profile_photo {
//                             file_name
//                             size
//                             mime_type
//                             s3_key
//                         }
//                     }
//                     is_active
//                 }
//                 inspection {
//                     inspector_id
//                     inspected_date
//                     inspector {
//                         id
//                         email
//                         user_roles
//                         cognito_status
//                         is_active
//                     }
//                     remarks
//                     attachments {
//                         file_name
//                         size
//                         mime_type
//                         s3_key
//                     }
//                 }
//                 defect_date
//                 defects {
//                     defect_checklist_code
//                     defect_checklist {
//                         code
//                         description {
//                             en
//                             ar
//                         }
//                     }
//                     remarks
//                     is_defect
//                     attachments {
//                         file_name
//                         size
//                         mime_type
//                         s3_key
//                     }
//                 }
//                 audit_info {
//                     created_by
//                     created_date
//                     modified_by
//                     modified_date
//                 }
//                 defect_status {
//                     code
//                     description {
//                         en
//                         ar
//                     }
//                 }
//             }
//         }
//     }
// `

export const GET_VESSEL_CHECK_SUBMISSION_DETAILS = gql`
    query GetVesselDefectSubmission(
        $defectSubmissionId: String
        $boatId: String
        $fromDate: LocalDate!
        $toDate: LocalDate!
        $defectStatus: String
        $page: PageInput!
    ) {
        getVesselDefectSubmission(
            defect_submission_id: $defectSubmissionId
            boat_id: $boatId
            from_date: $fromDate
            to_date: $toDate
            defect_status: $defectStatus
            page: $page
        ) {
            success
            message
            total_count
            defects {
                defect_submission_id
                vessel {
                    boat_id
                    boat {
                        id
                        name {
                            en
                            ar
                        }
                        details {
                            boat_type {
                                code
                            }
                            reg_number
                            capacity
                            features_amenities {
                                code
                            }
                            safety_equipment {
                                code
                            }
                            images {
                                file_name
                                size
                                mime_type
                                s3_key
                            }
                        }
                        status {
                            code
                        }
                        seat_layout {
                            layout_id
                            layout_key
                            num_rows
                            num_columns
                            seats_config {
                                seats {
                                    row
                                    column
                                    seat_number
                                }
                            }
                        }
                        user_audit {
                            created_by
                            created_date
                            modified_by
                            modified_date
                        }
                    }
                }
                captain_id
                captain {
                    id
                    email
                    user_info {
                        phone_number
                        phone_number_verified
                        given_name
                        family_name
                        nationality_code
                        date_of_birth
                        locale
                        photo {
                            file_name
                            size
                            mime_type
                            s3_key
                        }
                    }
                    user_roles
                    cognito_status
                    additional_info {
                        job_title
                        document_number
                        document_type {
                            code
                        }
                        document {
                            file_name
                            size
                            mime_type
                            s3_key
                        }
                        profile_photo {
                            file_name
                            size
                            mime_type
                            s3_key
                        }
                    }
                    is_active
                }
                inspection {
                    inspector_id
                    inspected_date
                    inspector {
                        id
                        email
                        user_roles
                        cognito_status
                        is_active
                    }
                    remarks
                    attachments {
                        file_name
                        size
                        mime_type
                        s3_key
                    }
                }
                defect_date
                defects {
                    defect_checklist_code
                    defect_checklist {
                        code
                        description {
                            en
                        }
                    }
                    remarks
                    is_defect
                    attachments {
                        file_name
                        size
                        mime_type
                        s3_key
                    }
                }
                audit_info {
                    created_by
                    created_date
                    modified_by
                    modified_date
                }
                defect_status {
                    code
                    description {
                        en
                        ar
                    }
                }
            }
        }
    }
`
export const GET_VESSEL_CHECKLIST_SUBMISSION_STATUS = gql`
    query VesselChecklistSubmissionStatus($code: String) {
        vesselChecklistSubmissionStatus(code: $code) {
            code
            description {
                en
                ar
            }
        }
    }
`

export const GET_CHECKIN_STATUS = gql`
    query Query($code: String) {
        checkinStatus(code: $code) {
            code
            description {
                en
                ar
            }
        }
    }
`

export const GET_LUGGAGE_STATUS = gql`
    query LuggageStatus($code: String) {
        luggageStatus(code: $code) {
            code
            description {
                en
                ar
            }
        }
    }
`

export const GET_LUGGAGE_TAG = gql`
    query LuggageTag($code: String) {
        luggageTag(code: $code) {
            code
            description {
                en
                ar
            }
        }
    }
`

export const GET_COUNTER_PASSENGER_CHECKINS = gql`
    query getCounterPassengerCheckIns(
        $bookingId: NonEmptyString!
        $checkinId: String
        $passengerId: String
        $status: String
        $travelDate: LocalDate
        $page: PageInput!
    ) {
        getCounterPassengerCheckIns(
            booking_id: $bookingId
            checkin_id: $checkinId
            passenger_id: $passengerId
            status: $status
            travel_date: $travelDate
            page: $page
        ) {
            code
            success
            message
            checkins {
                checkin_id
                booking_id
                passenger_id
                luggage_count
                travel_date
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
                details {
                    remarks
                    counter_no
                }
                user_audit {
                    created_by
                    created_date
                    modified_by
                    modified_date
                }
                luggages {
                    booking_id
                    checkin_id
                    travel_date
                    luggage_id
                    qr_code {
                        encrypted
                    }
                    status {
                        code
                        description {
                            en
                            ar
                        }
                    }
                    details {
                        weight
                        dimensions {
                            length
                            width
                            height
                        }
                        color
                        tags
                    }
                    user_audit {
                        created_by
                        created_date
                        modified_by
                        modified_date
                    }
                }
            }
        }
    }
`

export const GET_TRIP_PASSENGERS = gql`
    query GetTripPassengers($tripId: NonEmptyString!, $tripDate: Date!) {
        getTripPassengers(trip_id: $tripId, trip_date: $tripDate) {
            code
            success
            message
            passengers {
                passenger_id
                booking_id
                trip_id
                travel_date
                booking_code
                passenger {
                    given_name
                    family_name
                    date_of_birth
                    document_number
                    document {
                        file_name
                        size
                        mime_type
                        s3_key
                    }
                    document_type
                    email
                    medical_condition
                    medical_remarks
                    phone_number
                    special_needs
                }
                ticket_number
                seat_type
                seat_no
                seat_status {
                    code
                    description {
                        en
                        ar
                    }
                }
                age_group_code
                age_group {
                    code
                    description {
                        en
                        ar
                    }
                }
                counter_status {
                    code
                    description {
                        en
                        ar
                    }
                }
            }
            trip_id
            travel_date
            crew_details {
                id
                email
                user_info {
                    phone_number
                    locale
                    given_name
                    family_name
                    date_of_birth
                    nationality_code
                }
                user_roles
                cognito_status
                is_active
                additional_info {
                    job_title
                    document_number
                    document_type {
                        code
                        description {
                            en
                            ar
                        }
                    }
                    document {
                        file_name
                        size
                        mime_type
                        s3_key
                    }
                    profile_photo {
                        file_name
                        size
                        mime_type
                        s3_key
                    }
                    attachments {
                        document_number
                        document_type
                        document {
                            file_name
                            size
                            mime_type
                            s3_key
                        }
                    }
                }
            }
        }
    }
`
